import { injectBaseConstantMethods } from "./BaseConstants";

/**
 * `User` mirrors the backend's UserType.USER (teacher/student accounts).
 *
 * DefaultLayout matches these values case-insensitively against the API's
 * `user.type` ("ADMIN" | "USER"), so the spelling here only has to survive
 * .toUpperCase() — the display strings below are what the UI shows.
 *
 * It exists because MCAP is no longer admin-only: any account, whatever its
 * type, can be granted entry from MCAP Access in the admin console, and the
 * 23 MCAP analytics endpoints now admit UserType.USER alongside
 * UserType.ADMIN. Without a `User` role here, a granted teacher would clear
 * the mcapAccess gate and then match zero routes — signed in, and staring at
 * nothing.
 */
const Roles = {
    Admin: "Admin",
    SuperAdmin: "Super Admin",
    User: "User"
};

const displayTextKeys = {
    [Roles.Admin]: "Admin",
    [Roles.SuperAdmin]: "Super Admin",
    [Roles.User]: "User"
};

const labelClass = {
    [Roles.Admin]: "admin",
    [Roles.SuperAdmin]: "super-admin",
    [Roles.User]: "user"
};

export default injectBaseConstantMethods(Roles, displayTextKeys, labelClass);
